import { useEffect, useState } from 'react';

const navLinks = [
  { href: '#today', label: '今日新料' },
  { href: '#explosive', label: '猛料速报' },
  { href: '#timeline', label: '事件内幕' },
  { href: '#hot', label: '热门榜' },
  { href: '#trust', label: '投稿与核实' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={
        'sticky top-0 z-50 w-full transition-colors duration-300 ' +
        (scrolled ? 'bg-[#faf9f7]/90 backdrop-blur border-b border-stone-200/70' : 'bg-transparent')
      }
    >
      <div className="mx-auto flex h-16 items-center justify-between gap-4 px-4 md:px-6 max-w-[1280px]">
        {/* 品牌 LOGO = H1 */}
        <a href="#top" className="flex shrink-0 items-center gap-2.5 whitespace-nowrap">
          <span className="grid h-9 w-9 place-items-center rounded-md bg-stone-950 text-white">
            <i className="ri-focus-3-fill text-lg" />
          </span>
          <span className="flex flex-col leading-none">
            <h1 className="font-display text-xl font-black tracking-wide text-stone-950">网黑料</h1>
            <span className="mt-1 text-[11px] font-medium tracking-widest text-stone-500">黑料 · 新料 · 猛料 · 快讯</span>
          </span>
        </a>

        {/* 桌面导航 */}
        <nav className="hidden items-center gap-7 md:flex">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="whitespace-nowrap text-sm font-medium text-stone-600 transition-colors hover:text-stone-950"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-3 md:flex">
          <span className="inline-flex items-center gap-1.5 rounded-full border border-stone-200 px-3 py-1 text-xs font-medium text-stone-500">
            <i className="ri-time-line" /> 今日已更 26 条
          </span>
          <a
            href="#report"
            className="inline-flex items-center gap-1.5 rounded-md bg-red-600 px-4 py-2 text-sm font-semibold text-white whitespace-nowrap transition-colors hover:bg-red-700"
          >
            <i className="ri-flashlight-line" /> 投稿爆料
          </a>
        </div>

        {/* 移动端汉堡 */}
        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-label="打开菜单"
          className="grid h-10 w-10 place-items-center rounded-md border border-stone-200 text-stone-700 md:hidden"
        >
          <i className={open ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} />
        </button>
      </div>

      {/* 移动端菜单 */}
      {open && (
        <div className="border-t border-stone-200 bg-[#faf9f7] px-4 py-4 md:hidden">
          <nav className="flex flex-col gap-1">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2.5 text-sm font-medium text-stone-700 hover:bg-stone-100"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#report"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex items-center justify-center gap-1.5 rounded-md bg-red-600 px-4 py-2.5 text-sm font-semibold text-white"
            >
              <i className="ri-flashlight-line" /> 投稿爆料
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}